import { Props_SnippetStatistics } from './Statistics.props';
import { CompileHeadingToSpan, CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

export const SnippetStatistics = (props: Props_SnippetStatistics) => {
    const { heading, eyebrow, summary, repeatable_entry } = props;
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

    const classHeadingVisibility = heading?.visibility?.value ? 'snippet-statistics__heading' : 'snippet-statistics__heading accessible-heading';
    
    return (
        <section className="snippet-statistics" ref={ref}>
            <div className="snippet-statistics__container">
                <div className="snippet-statistics__heading-container">
                    <h2 className={classHeadingVisibility}>{CompileHeadingToSpan(heading?.content?.value || '')}</h2>
                    {eyebrow?.text?.value && (
                        <p className="snippet-statistics__eyebrow">{eyebrow.text.value}</p>
                    )}
                    {summary?.content?.value && (
                        <div className="snippet-statistics__summary">
                            {CompileMarkdown(summary.content.value)}
                        </div>
                    )}
                </div>
                <div className="snippet-statistics__container-items">
                    {repeatable_entry.map((entry, index) => (
                        <div key={index} className="snippet-statistics__item">
                            {entry.number?.value && (
                                <div className="snippet-statistics__number">
                                    {entry.labelBefore?.value && <span className="snippet-statistics__label">{entry.labelBefore.value}</span>}
                                    <h3>
                                    <CountUp 
                                        start={inView ? 0 : undefined} 
                                        end={parseFloat(entry.number.value.replace(',', '.')) || 0} 
                                        duration={2.5} 
                                        separator="," 
                                        decimal="." 
                                        decimals={entry.number.value.includes(',') || entry.number.value.includes('.') ? 1 : 0} 
                                    />
                                    </h3>
                                    {entry.labelAfter?.value && <span className="snippet-statistics__label">{entry.labelAfter.value}</span>}
                                </div>
                            )}
                            {entry.description?.value && (
                                <div className="snippet-statistics__item-description">
                                    {CompileMarkdown(entry.description.value)}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};